<template>
  <el-dialog  title="提货"  :visible.sync="dialog" width="1100px" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  center>
    <div>
 <el-form :inline="true" :model="addFrom" ref="addFrom"  :rules="rules"  class="demo-form-inline jiaoyan" label-width="120px" size="mini" >
   <el-form-item label="有效期至:" prop="validityTime" v-if="rowData.zhanshiFLag[0]"  >
          <el-date-picker
            v-model="addFrom.validityTime"
            type="datetime"
            value-format="timestamp"
              placeholder="选择日期时间"
                :picker-options="pickerOptions"
                 @change="changeDateFn"
          ></el-date-picker>
    </el-form-item>
    <el-form-item label="是否扣车:" prop="isCarHold" v-if="rowData.zhanshiFLag[1]" >
        <template >
          <el-radio-group v-model="addFrom.isCarHold" >
            <el-radio :label="1" >是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </template>
      </el-form-item>
      <el-form-item label="外部提单号:" prop="outBillNo"  :rules="rowData.zhanshiFLag[2] ? rules.outBillNo:[{required: false}]" >
           <el-input  placeholder=""   maxlength="30" v-model="addFrom.outBillNo" ></el-input>
    </el-form-item>
      <div style="text-align: center;margin-bottom:20px" >
          <el-input type="textarea" style="width: 95%;" maxlength="200" placeholder="请输入备注信息" v-model="addFrom.remark" onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
      </div>
      <div class="addressBox" style="margin-bottom:-30px">
        <h4 class="title">
          <span><i class="fa fa-truck" aria-hidden="true"></i>人车信息</span>
          <el-form-item style="margin-left:16px" v-if="rowData.zhanshiFLag[4]">
            <el-input type="textarea" v-model="carNumber" style="width: 400px;" rows="3"></el-input>
          </el-form-item>
           <el-form-item style="margin-left:16px">
             <el-button type="primary" @click="shiBieFN(carNumber)" v-if="rowData.zhanshiFLag[4]">识别</el-button>
             <el-button type="primary" @click="qingkongFN(carNumber)" v-if="rowData.zhanshiFLag[4]">清空</el-button>
             <el-button type="primary" @click="addFN">新增</el-button>
          </el-form-item>
        </h4>
      </div>
       <el-table :data="addFrom.billCarriageInfos"  ref="table"   bordersize="mini"    style="width: 100%" height="300"   center border>
         <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
          <el-table-column label="提货车号" width="270">
            <template slot="header" >
              <div><span class="red">*</span>提货车号</div>
            </template>
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'billCarriageInfos.' +scope.$index+ '.vhcNo'" :key="scope.$index" :rules="rules.vhcNo" class="table_error">
                <!-- <el-input  placeholder=""     maxlength="10"     v-model="addFrom.billCarriageInfos[scope.$index].vhcNo"></el-input> -->
                <el-autocomplete class="inline-input" v-model.trim="addFrom.billCarriageInfos[scope.$index].vhcNo"
                  :fetch-suggestions="querySearch" value-key="vhcNo"  @select="handleSelect($event,scope.$index)" popper-class="xiala" :validate-event = "false">
                   <template slot-scope="{ item }">
                     <div style="position: relative;">
                        <div class="name">{{ item.vhcNo }},{{ item.driverName }}</div>
                        <span class="addr">{{ item.driverIdentityNo? item.driverIdentityNo:''}}</span>
                        <span class="el-icon-close" style="position: absolute; right: 0;top: 4px;" @click.stop="delRenche(item)"></span>
                     </div>
                  </template>
                </el-autocomplete>

              </el-form-item>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="司机姓名" width="170">
           <template slot="header" >
              <div><span class="red">*</span>司机姓名</div>
            </template>
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'billCarriageInfos.' +scope.$index+ '.driverName'" :key="scope.$index" :rules="rules.driverName" class="table_error" >
                <el-input  placeholder=""  maxlength="10"     v-model.trim="addFrom.billCarriageInfos[scope.$index].driverName"></el-input>
              </el-form-item>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="身份证号" min-width="170">
            <template slot="header" >
              <div><span class="red" v-if="rowData.zhanshiFLag[3]">*</span>身份证号</div>
            </template>
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'billCarriageInfos.' +scope.$index+ '.driverIdentityNo'" :key="scope.$index" :rules="rowData.zhanshiFLag[3]?rules.driverIdentityNo:[{required: false}]" class="table_error" >
                <el-input  placeholder=""  maxlength="18"     v-model.trim="addFrom.billCarriageInfos[scope.$index].driverIdentityNo"></el-input>
              </el-form-item>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="联系电话" width="170">
           <template slot="header" >
              <div><span class="red"  v-if="rowData.zhanshiFLag[5]">*</span>联系电话</div>
            </template>
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'billCarriageInfos.' +scope.$index+ '.driverMobile'" :key="scope.$index" :rules="rowData.zhanshiFLag[5]?rules.driverMobile:[{required: false}]" class="table_error">
                <el-input  placeholder=""   maxlength="11"     v-model.trim="addFrom.billCarriageInfos[scope.$index].driverMobile"></el-input>
              </el-form-item>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini"  v-if="rowData.janFaFlag!=1"  @click="carFn(scope.$index)">选择车辆</el-button>
              <el-button type="text" size="mini"  v-if="rowData.janFaFlag!=1"  @click="sijiFn(scope.$index)">选择司机</el-button>
               <el-button type="text" size="mini"  v-if="rowData.janFaFlag==1"  @click="zhipai(scope.$index)">指派</el-button>
              <el-button type="text" size="mini"   @click="delFN(scope.$index)">删除</el-button>
            </div>
          </template>
        </el-table-column>
       </el-table>
 </el-form>
    </div>
     <span slot="footer" class="dialog-footer">
       <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
      <!-- 选择司机 -->
      <el-dialog append-to-body title="选择司机" :visible.sync="sijiMark" @close="closeDialog1"  :close-on-click-modal="false" width="900px" center>
        <!-- 内容 -->
        <div>
          <div ref="searchBox"  style="margin:26px 0">
            <el-form :inline="true" :model="derverFrom" ref="derverFrom" class="demo-form-inline" label-width="86px" size="mini">
                  <div class="searchBox inpBox" >
                      <div>
                        <el-form-item label="司机姓名:" prop="name">
                          <el-input  placeholder=""   type="text" v-model="derverFrom.name" ></el-input>
                        </el-form-item>
                        <el-form-item>
                        <el-button type="primary" @click="SJsearchFn">查询</el-button>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="resetForm('derverFrom')">重置</el-button>
                      </el-form-item>
                      </div>
                  </div>
            </el-form>
            </div>
          <!-- 表格数据 -->
          <div class="tableQiye">
            <!-- 表格 -->
            <div>
              <el-table :data="sijiList"  ref="xzdz" height="500" v-loading="loading1"     highlight-current-row   >
                <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
                <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                      <el-button type="text"  @click="sijiOK(scope.row)" size="mini">选择司机</el-button>
                    </template>
                  </el-table-column>
                <el-table-column prop="name" width="120" :show-overflow-tooltip="true"  label="司机姓名"></el-table-column>
                <el-table-column property="identityNo" label="身份证号" min-width="200">
                  <template scope="scope">
                    <p>{{scope.row.identityNo}}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="mobile" width="150" label="联系电话"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div>
            <el-pagination background
              @size-change="derverChange"
              @current-change="derverCurrentChange"
              :current-page="derverFrom.pageNo"
              :page-sizes="[25,50,100,200,1000]"
              :page-size="derverFrom.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="SJtotal">
            </el-pagination>
          </div>
        <div style="width:158px;margin:15px auto;">
          <el-button type="primary" @click="sijiMark=false">关闭</el-button>
        </div>
      </el-dialog>
      <!-- 选择车辆 -->
      <el-dialog append-to-body title="选择车辆" :visible.sync="carMark" @close="closeDialog1"  :close-on-click-modal="false" width="900px" center>
        <!-- 内容 -->
        <div>
          <el-form :inline="true" :model="carFrom" class="demo-form-inline" label-width="86px" size="mini">
            <div class="searchBox inpBox" >
                <div>
                  <el-form-item label="车牌号:" prop="vhcNo">
                    <el-input  placeholder="" v-model="carFrom.vhcNo"></el-input>
                  </el-form-item>
                  <el-form-item>
                  <el-button type="primary" @click="carSearchFn">查询</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="resetForm('derverFrom')">重置</el-button>
                  </el-form-item>
                </div>
            </div>
          </el-form>
          <!-- 表格数据 -->
          <div class="tableQiye">
            <!-- 表格 -->
            <div>
              <el-table :data="carList" ref="table" v-loading="loading1" bordersize="mini"
                  class="table" height="380px" style="width: 100%"   center  border   >
                <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text"  @click="carOk(scope.row)" size="mini">选择车辆</el-button>
                  </template>
                </el-table-column>
               <el-table-column prop="vhcNo"  width="100" label="车牌号"></el-table-column>
                <el-table-column prop="vhcTypeName"  width="150" :show-overflow-tooltip="true" label="车辆类型"></el-table-column>
                <el-table-column prop="weight" width="100"  :show-overflow-tooltip="true"  label="载重(吨)"></el-table-column>
                <el-table-column prop="energyName"  width="150" :show-overflow-tooltip="true" label="能源类型"></el-table-column>
                <el-table-column prop="standardsName" width="80" :show-overflow-tooltip="true" label="排放标准"></el-table-column>
              <el-table-column property="vhcCompanyName" width="240"  :show-overflow-tooltip="true" label="所属单位/个人" > </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
         <el-pagination background
          @size-change="carChange"
          @current-change="carCurrentChange"
          :current-page="carFrom.pageNo"
          :page-sizes="[25,50,100,200,1000]"
          :page-size="carFrom.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="carTotal">
        </el-pagination>
        <div style="width:158px;margin:15px auto;">
          <el-button type="primary" @click="carMark=false">关闭</el-button>
        </div>
      </el-dialog>
      <!-- 指派 -->
      <zhipai   v-if="zhipaiFlag" @destroy="destroy" @zhipaiSave="zhipaiSave"></zhipai>
   </el-dialog>
</template>

<script>
import { sVirtualBillAdd, selectCommonDictionary, sBillCarriageInfoList, sCarriageLogDelete, formatVehNo, getLatestVehicleDriverInfo } from '@/api/soc-stock-cosco'
import { cDlist, cVIlist } from '@/api/vgs-driver'
import zhipai from '@/views/soc-stock-cosco/inventoryMonitore/zhipai.vue'
export default {
  components: {
    zhipai
  },
  name: 'lookVoucher',
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dialog: true,
      zhipaiFlag: false,
      addFrom: {
        billCarriageInfos: [{}]
      },
      rules: {
        validityTime: [{ required: true, message: '请选择有效期至', trigger: 'blur' }],
        isCarHold: [{ required: true, message: '请选择是否扣车', trigger: 'blur' }],
        driverName: [
          { required: true, message: '请输入司机姓名', trigger: 'blur' }
        ],
        driverIdentityNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        driverMobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        vhcNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          this.rule.vhcNo
        ],
        outBillNo: [
          { required: true, message: '请输入外部单号', trigger: 'blur' }
        ]
      },
      // 司机列表
      loading1: false,
      sijiMark: false,
      derverFrom: {
        pageNo: 1,
        pageSize: 50
      },
      sijiList: [],
      SJtotal: 0,
      // 车辆列表
      carMark: false,
      carFrom: {
        pageNo: 1,
        pageSize: 50
      },
      carList: [],
      carTotal: 0,
      carDerList: [],
      currentIndx: 0,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      callback: null,
      searchStr: '',
      carNumber: '',
      vehNoList: [],
      allList: [],
      allVehNoList: []

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    sBillCarriageInfoList({ isDistinct: '1', billCategory: 2 }).then(res => {
      this.carDerList = res
    }).catch(error => {
      this.$message({
        showClose: true,
        message: error.message,
        type: 'error',
        onClose () {
        }
      })
    })
    if (this.rowData.zhanshiFLag[0]) {
      var time = Date.now() + 48 * 60 * 60 * 1000
      this.$set(this.addFrom, 'validityTime', time)
    }
  },
  methods: {
    // 识别车号
    shiBieFN (val) {
      console.log(val, 'val')
      this.getLatestVehicleDriverInfo(val)
      // let formData = new FormData()
      // formData.append('vehNoString', val)
      // formatVehNo(formData).then(res => {
      //   this.vehNoList = Array.from(new Set(res.vehNoList))
      //   if (res.vehNoList.length > 20) {
      //     this.$message.error('车辆数量限制为20个')
      //   } else {
      //     this.getLatestVehicleDriverInfo(this.vehNoList)
      //     if (res.errorVehNoList.length != 0) {
      //       this.$message.error(res.errorVehNoList.join() + '车号在系统不存在，请核实车号')
      //     }
      //   }
      // }).catch(error => {
      //   this.$message({
      //     showClose: true,
      //     message: error.message,
      //     type: 'error',
      //     onClose () {
      //     }
      //   })
      // })
    },
    getLatestVehicleDriverInfo (val) {
      getLatestVehicleDriverInfo({ billCategory: 2,
        vehNoString: val }).then(res => {
        if (res.vehNoList.length > 20) {
          this.$message.error('车辆数量限制为20个')
        } else {
          this.allVehNoList = res.vehNoList
          if (this.addFrom.billCarriageInfos.length == 0) {
            this.addFrom.billCarriageInfos.push({})
          }
          if (!this.addFrom.billCarriageInfos[0].vhcNo) {
            this.addFrom.billCarriageInfos = []
          }
          this.addFrom.billCarriageInfos = this.addFrom.billCarriageInfos.filter(item => item.vhcNo != undefined)

          for (let j = 0; j < this.allVehNoList.length; j++) {
            if (this.addFrom.billCarriageInfos.some(item => item.vhcNo == this.allVehNoList[j].vhcNo)) continue
            this.addFrom.billCarriageInfos.push({
              vhcNo: this.allVehNoList[j].vhcNo,
              driverName: this.allVehNoList[j].driverName,
              driverIdentityNo: this.allVehNoList[j].driverIdentityNo,
              driverMobile: this.allVehNoList[j].driverMobile
            })
          }
          if (res.errorVehNoList.length != 0) {
            this.$message.error(res.errorVehNoList.join() + '识别失败，请核实')
          }
        }

        // for (let i = 0; i < this.vehNoList.length; i++) {
        //   for (let j = 0; j < this.allVehNoList.length; j++) {
        //     if (this.vehNoList[i] == this.allVehNoList[j].vhcNo) {
        //       if (this.addFrom.billCarriageInfos.some(item => item.vhcNo == this.vehNoList[i])) continue
        //       this.addFrom.billCarriageInfos.push({})
        //       this.$set(this.addFrom.billCarriageInfos[this.addFrom.billCarriageInfos.length - 1], 'vhcNo', this.allVehNoList[j].vhcNo)
        //       this.$set(this.addFrom.billCarriageInfos[this.addFrom.billCarriageInfos.length - 1], 'driverName', this.allVehNoList[j].driverName)
        //       this.$set(this.addFrom.billCarriageInfos[this.addFrom.billCarriageInfos.length - 1], 'driverIdentityNo', this.allVehNoList[j].driverIdentityNo)
        //       this.$set(this.addFrom.billCarriageInfos[this.addFrom.billCarriageInfos.length - 1], 'driverMobile', this.allVehNoList[j].driverMobile)
        //     } else {
        //       if (this.addFrom.billCarriageInfos.some(item => item.vhcNo == this.vehNoList[i])) continue
        //       if (j == this.allVehNoList.length - 1) {
        //         this.addFrom.billCarriageInfos.push({})
        //         this.$set(this.addFrom.billCarriageInfos[this.addFrom.billCarriageInfos.length - 1], 'vhcNo', this.vehNoList[i])
        //       }
        //     }
        //   }
        // }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 清空车号
    qingkongFN (val) {
      this.carNumber = ''
      this.addFrom.billCarriageInfos = [{}]
    },
    // 删除下拉得人车
    delRenche (item) {
      sCarriageLogDelete({ id: item.id }).then(res => {
        sBillCarriageInfoList({ isDistinct: '1', billCategory: 2 }).then(res => {
          this.carDerList = res
          this.querySearch(this.searchStr, this.callback)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },

    // 指派
    zhipai (index) {
      this.currentIndx = index
      this.zhipaiFlag = true
    },
    zhipaiSave (row) {
      this.$set(this.addFrom.billCarriageInfos[this.currentIndx], 'driverName', row.driverName)
      this.$set(this.addFrom.billCarriageInfos[this.currentIndx], 'driverIdentityNo', row.driverIdentityNo)
      this.$set(this.addFrom.billCarriageInfos[this.currentIndx], 'driverMobile', row.driverMobile)
      this.$set(this.addFrom.billCarriageInfos[this.currentIndx], 'vhcNo', row.vhcNo)
      this.zhipaiFlag = false
    },
    destroy () {
      this.zhipaiFlag = false
    },
    querySearch (str, cb) {
      console.log(2222)
      let arr = []
      this.carDerList.forEach(itme => {
        if (str) {
          if (itme.vhcNo.indexOf(str) != -1) {
            arr.push(itme)
          }
        } else {
          arr.push(itme)
        }
      })
      this.callback = cb
      this.searchStr = str
      cb(arr)
    },
    handleSelect (row, index) {
      this.$set(this.addFrom.billCarriageInfos[index], 'driverName', row.driverName)
      this.$set(this.addFrom.billCarriageInfos[index], 'driverIdentityNo', row.driverIdentityNo)
      this.$set(this.addFrom.billCarriageInfos[index], 'driverMobile', row.driverMobile)
      this.allList.push(this.addFrom.billCarriageInfos[index])
      console.log(this.allList)
    },
    // 选择有效期至
    changeDateFn () {
      let timestamp = new Date().getTime()
      if (this.addFrom.validityTime < timestamp) {
        this.$alert('有效期至需要大于当前时间', '系统提示')
        this.$set(this.addFrom, 'validityTime', null)
      }
    },
    // 选择司机
    sijiFn (index) {
      this.sijiMark = true
      this.SJsearchFn()
      this.currentIndx = index
    },
    sijiOK (row) {
      this.$set(this.addFrom.billCarriageInfos[this.currentIndx], 'driverName', row.name)
      this.$set(this.addFrom.billCarriageInfos[this.currentIndx], 'driverIdentityNo', row.identityNo)
      this.$set(this.addFrom.billCarriageInfos[this.currentIndx], 'driverMobile', row.mobile)
      this.sijiMark = false
    },
    // 选择车辆
    carFn (index) {
      this.carMark = true
      this.carSearchFn()
      this.currentIndx = index
    },
    carOk (row) {
      this.$set(this.addFrom.billCarriageInfos[this.currentIndx], 'vhcNo', row.vhcNo)
      this.carMark = false
    },
    // 添加人车
    addFN () {
      this.addFrom.billCarriageInfos.push({})
    },
    // 删除人车
    delFN (n) {
      this.addFrom.billCarriageInfos.splice(n, 1)
    },
    saveFn () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          this.addFrom.sVirtualGoods = this.rowData.goodList
          if (this.addFrom.billCarriageInfos.length > 20) {
            this.$alert('车辆数量不得超过20个', '系统提示')
            return
          }
          if (this.addFrom.billCarriageInfos.length == 0) {
            this.$alert('请维护人车信息', '系统提示')
            return
          }
          let arr = Array.from(new Set(this.addFrom.billCarriageInfos.map(item => item.vhcNo)))
          if (arr.length != this.addFrom.billCarriageInfos.length) {
            this.$alert('提货车号不能重复', '系统提示')
            return
          }
          const ids = []
          this.addFrom.billCarriageInfos.forEach(value => {
            if (value.driverIdentityNo) {
              ids.push(value.driverIdentityNo)
            }
          })
          if (ids.length > 0) {
            const idsSet = new Set(ids)
            if ([...idsSet].length != ids.length) {
              this.$alert('人车信息身份证号不能重复', '系统提示')
              return
            }
          }
          if (this.rowData.janFaFlag == 1) {
            this.addFrom.janFaFlag = 1
          }
          // return
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          sVirtualBillAdd(this.addFrom).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.$router.push({ path: '/ZYtakeGoodsBill' })
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 司机列表
    SJsearchFn () {
      this.getDerverList()
    },
    getDerverList () {
      this.loading1 = true
      cDlist(this.derverFrom).then(res => {
        this.loading1 = false
        this.sijiList = res.list
        this.SJtotal = res.total
      })
    },
    derverChange (val) {
      this.derverFrom.pageSize = val
      this.getDerverList()
    },
    derverCurrentChange (val) {
      this.derverFrom.pageNo = val
      this.getDerverList()
    },
    // 车辆列表
    carSearchFn () {
      this.getCarlist()
    },
    getCarlist () {
      this.loading1 = true
      cVIlist(this.carFrom).then(res => {
        this.loading1 = false
        this.carList = res.list
        this.carTotal = res.total
      })
    },
    carChange (val) {
      this.carFrom.pageSize = val
      this.getDerverList()
    },
    carCurrentChange (val) {
      this.carFrom.pageNo = val
      this.getDerverList()
    },
    // 重置
    resetForm (formName) {
      this.derverFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.carFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    closeDialog1 () {
      this.derverFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.carFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    closeDialog () {
      this.$emit('destroy')
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-form--inline .diqu .el-form-item__content{
      flex-direction: row;
}
/deep/.el-image {
  margin: 10px;
}

/deep/.jiaoyan .el-form-item--mini.table_error{
  margin-bottom: 0 !important;
    margin: 6px 0!important;
}
/deep/ .el-popper{
   width: 200px!important;
}
.xiala{
  .name{
    color: #000;
    line-height:normal;
    margin-top:6px;
  }
  .addr{
    color: #999;
  }
}
/deep/.el-autocomplete {
  width: 210px;
}
</style>
